import AuthorizedRoute from "containers/Page/Permissions/AuthorizedRoute";
import React, { lazy, ReactElement } from "react";
import UnauthorizedRoute from "containers/Page/Permissions/UnauthorizedRoute";

type DefaultRoute = {
  path: string;
  exact?: boolean;
  element: ReactElement;
};

const SignIn = lazy(() => import("../pages/SignIn"));
const PageNotFound = lazy(() => import("../pages/PageNotFound"));
const ResetPassword = lazy(
  () => import("../pages/ResetPassword/ResetPassword"),
);
const SelectTenant = lazy(() => import("../pages/SelectTenant"));
const InternalOpen = lazy(() => import("../pages/InternalOpen"));
const AuthAction = lazy(() => import("../pages/AuthAction/AuthAction"));

const getDefaultRoutes = (
  // Not read: routes here are unconditional. Kept for interface parity with
  // callers (see containers/Layout/BaseLayout.js) that pass the app config in.
  appConfig: unknown,
): DefaultRoute[] => {
  return [
    {
      path: "/",
      exact: true,
      element: (
        <UnauthorizedRoute>
          <SignIn />
        </UnauthorizedRoute>
      ),
    },
    {
      path: "/signin/:tenantId",
      exact: true,
      element: (
        <UnauthorizedRoute>
          <SignIn />
        </UnauthorizedRoute>
      ),
    },
    {
      path: "/reset-password",
      exact: true,
      element: (
        <UnauthorizedRoute>
          <ResetPassword />
        </UnauthorizedRoute>
      ),
    },
    {
      // No UnauthorizedRoute: a signed-in user may still follow a reset link.
      path: "/auth/action",
      exact: true,
      element: <AuthAction />,
    },
    {
      path: "/select-tenant",
      exact: true,
      element: <SelectTenant />,
    },
    {
      path: "/internal/open",
      exact: true,
      element: <InternalOpen />,
    },
    {
      path: "*",
      element: (
        <AuthorizedRoute>
          <PageNotFound />
        </AuthorizedRoute>
      ),
    },
  ];
};

export { getDefaultRoutes };
